import type {
  AssetFragment,
  DefaultImageUrlTransformationFragment,
  InlineBannerImageUrlTransformationFragment,
  PrimaryBannerImageUrlTransformationFragment,
} from '@seek/cmsu-cms-connect';
import { resizeImageMaxSize } from '@seek/cmsu-rich-text/src/utils/resizeImageMaxSize';
import React, { type CSSProperties } from 'react';

type Props = Pick<AssetFragment, 'alt' | 'mimeType'> &
  Pick<
    | DefaultImageUrlTransformationFragment
    | PrimaryBannerImageUrlTransformationFragment
    | InlineBannerImageUrlTransformationFragment,
    'url'
  > & {
    style?: CSSProperties;
  };

export const Asset = ({ url, alt, style, mimeType }: Props) => (
  <img
    data-testid="assetTestId"
    src={!mimeType?.includes('svg') ? resizeImageMaxSize(url) : url}
    alt={alt || undefined}
    style={{
      maxWidth: '100%',
      maxHeight: '100%',
      ...style,
    }}
  />
);
